import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex justify-center py-25 relative z-51" }
const _hoisted_2 = ["href", "aria-label"]
const _hoisted_3 = { class: "flex justify-center items-center py-25 relative z-51" }
const _hoisted_4 = { class: "c-magic-line xl:text-16 hidden sm:inline" }
const _hoisted_5 = ["href", "aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "absolute right-0 flex items-center gap-x2 mr-20 w-1/3 justify-end xl:mr-64"
}
const _hoisted_7 = { class: "xl:text-16 hidden sm:inline-block truncate text-right flex-1" }

import { computed, Ref } from 'vue';
import MobilePageHeader from '@/shared/layout/page-header/mobile/MobilePageHeader.vue';
import DesktopPageHeader from '@/shared/layout/page-header/desktop/DesktopPageHeader.vue';
import SiteLayout from '@/shared/content/SiteLayout.vue';
import TopBar from '@/shared/layout/page-header/top-bar/TopBar.vue';
import { PromotionBannerModel } from '@/types/B2BcontentServerContract';
import siteContextStore from '@/shared/content/site-context.store';
import BusinessComponent from '@/shared/layout/Business/BusinessComponent.vue';
import SkipNavigationLink from '@/shared/navigation/site-navigation/SkipNavigationLink.vue';
import InternationalCountryPicker from '@/shared/layout/page-header/InternationalCountryPicker.vue';
import BasketLink from '@/shared/navigation/BasketLink.vue';
import ToggleNetPrice from '@/b2b/shared/auth/ui/ToggleNetPrice.vue';
import useProfile from '@/shared/navigation/site-navigation/useProfile';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  setup(__props) {

const { accountName, isSignedInAsPartner, hideNetPrice } = useProfile();
const frontpageLink = computed(() => siteContextStore.settings.frontPageUrl);
const promotionBanner: Ref<PromotionBannerModel | null> = computed(() => {
    return siteContextStore.promotionBanner;
});


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_Breakpoints = _resolveComponent("Breakpoints")!

  return (_openBlock(), _createBlock(SiteLayout, null, {
    Tunnel: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("a", {
          href: _unref(frontpageLink),
          "aria-label": _ctx.$dictionary.get('global/a11y/gotofrontpage')
        }, [
          _createVNode(_component_c_icon, {
            name: "icon-bolia-logo-simple",
            class: "w-70 h-18 lg:w-100 lg:h-25 lg:my-8"
          })
        ], 8, _hoisted_2)
      ])
    ]),
    Checkout: _withCtx(() => [
      _createVNode(BusinessComponent, { name: "TopNavigation" }),
      _createElementVNode("header", _hoisted_3, [
        _createVNode(BasketLink, {
          class: "absolute left-0 ml-20 xl:ml-64",
          "aria-label": _ctx.$dictionary.get('storecontext/pageHeaderBackToBasketLinkText')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_c_icon, {
              name: "icon-arrow-small",
              class: "rotate-180 h-14 sm:h-8 mr-1 sm:-mt-2 xl:h-10 xl:mr-3 xl:-mt-1"
            }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$dictionary.get('storecontext/pageHeaderBackToBasketLinkText')), 1)
          ]),
          _: 1
        }, 8, ["aria-label"]),
        _createElementVNode("a", {
          href: _unref(frontpageLink),
          "aria-label": _ctx.$dictionary.get('global/a11y/gotofrontpage')
        }, [
          _createVNode(_component_c_icon, {
            name: "icon-bolia-logo-simple",
            "aria-hidden": "true",
            class: "w-70 h-18 lg:w-100 lg:h-25 lg:my-8"
          })
        ], 8, _hoisted_5),
        (_unref(isSignedInAsPartner))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(accountName)), 1),
              (!_unref(hideNetPrice))
                ? (_openBlock(), _createBlock(ToggleNetPrice, {
                    key: 0,
                    class: "-mt-1",
                    title: _unref(accountName)
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    Full: _withCtx(() => [
      _createElementVNode("div", {
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(InternationalCountryPicker),
        _createVNode(BusinessComponent, { name: "TopNavigation" }),
        _createVNode(TopBar, { banner: _unref(promotionBanner) }, null, 8, ["banner"]),
        _createVNode(SkipNavigationLink),
        _createVNode(_component_Breakpoints, null, {
          "max-md": _withCtx(() => [
            _createVNode(MobilePageHeader)
          ]),
          "min-lg": _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(DesktopPageHeader)
            ])
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }))
}
}

})